module.exports = __webpack_public_path__ + "static/media/voluntarios.ca52aaf2.jpg";